import { ModalWithToggle } from "../../../../src/components/ModalWithToggle";
import * as React from 'react';
export default {
  ModalWithToggle,
  React
};